import * as actionTypes from '../actions/actionTypes';

export default function countryInfoDataReducer(state = [], action) {
  switch(action.type){
  case actionTypes.SET_COUNTRY_INFO_DATA: {
        return action.countryInfoData;
    }
    default: {
      return state;
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/createAcase/reducers/countryInfoDataReducer.js